import React from 'react';
import { isMobile, isTablet } from 'react-device-detect';
import PropTypes from 'prop-types';
import styles from './magazine.css';

const Magazine = ({ image, title }) => {
  return (
    <div
      className={`${styles.wrapper} ${
        isMobile || isTablet ? '' : styles.noTouch
      }`}>
      <figure className={styles.figure}>
        <img
          className={styles.magazine}
          src={image.placeholder || image}
          srcSet={image.srcSet}
          alt={title}
        />
      </figure>
    </div>
  );
};

Magazine.propTypes = {
  image: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
  ]),
  title: PropTypes.string.isRequired,
};

export default Magazine;
